// @flow

import React from 'react';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import Icon from '../components/Icons';
import { TERMS_NAV_LABEL, TERMS_URL } from '../Auth/Signup/termsCopy';

import ParkChicagoLogoInverse from '../assets/park-chicago-logo-inverse';
import PoweredByPassport from '../assets/icons/powered-by-passport-svg';

import typeof TTheme from '../theme';
import ReactGA from 'react-ga';

type TP = { theme: TTheme };
type Props = { className: string };

const ParkChicagoLogoContainer = styled(NavLink)`
  text-align: center;
  display: block;
  @media ${({ theme }: TP) => theme.mediaQueries.small} {
    flex: 1;
  }
`;

const IconContainer = styled(Icon)`
  display: inline-block;
  font-size: 16px;
  line-height: 30px;
  margin-left: 25px;
  margin-right: 10px;
  vertical-align: middle;
`;

const Header = styled.strong`
  color: ${({ theme }: TP) => theme.colors.white50};
  display: block;
  font-size: ${({ theme }: TP) => theme.typography.size.medium};
  margin-bottom: 5px;
  margin-top: 20px;
  text-transform: uppercase;
`;

const activeLinkClassName = 'active';
const linkStyles = css`
  color: ${({ theme }: TP) => theme.colors.white};
  display: block;
  font-size: ${({ theme }: TP) => theme.typography.size.standard};
  line-height: ${({ theme }: TP) =>
    30 / parseInt(theme.typography.size.standard, 10)};
  text-decoration: none;
  &:hover,
  &:focus,
  &.${activeLinkClassName} {
    background-color: ${({ theme }: TP) => theme.colors.black20};
    border-radius: 3px;
  }
`;

const Link = styled(NavLink)`
  ${linkStyles};
`;

// NavLink requires a router `to`, so external destinations need a plain anchor
// that reuses the same styles.
const ExternalLink = styled.a`
  ${linkStyles};
`;

const FooterLogo = styled.div`
  bottom: 36px;
  color: ${({ theme }: TP) => theme.colors.black20};
  left: 0;
  position: fixed;
  text-align: center;
  width: inherit;
  @media ${({ theme }: TP) => theme.mediaQueries.small} {
    display: none;
  }
`;

const HeaderContainer = styled.div`
  > ._z {
    display: none;
  }
  @media ${({ theme }: TP) => theme.mediaQueries.small} {
    align-items: center;
    color: ${({ theme }: TP) => theme.colors.white};
    display: flex;
    font-size: 16px;
    height: 60px;
    padding: 0 1em;
    text-align: center;
    > ._z {
      display: block;
    }
  }
`;

type State = {
  open: boolean,
};

const Nav = styled.div`
  @media ${({ theme }: TP) => theme.mediaQueries.small} {
    display: ${({ open }) => (open ? 'block' : 'none')};
    padding-bottom: ${({ theme }: TP) => theme.spacing.small};
  }
`;

class Navigation extends React.Component<Props, State> {
  state = { open: false };
  toggle = () => this.setState({ open: !this.state.open });
  close = (e: SyntheticEvent<HTMLFormElement>) => {
    // GOOGLE ANALYTICS: logout
    if (e.target.getAttribute('href') === '/logout') {
      ReactGA.event({
        category: 'Logout',
        action: 'User clicks "Logout" in the navigation',
        label: 'Log Out',
      });
    }
    this.setState({ open: false });
  };
  render() {
    const { className } = this.props;
    return (
      <div className={className}>
        <HeaderContainer>
          <Icon className="_z" type="menu" onClick={this.toggle} />
          <ParkChicagoLogoContainer to="/history">
            <ParkChicagoLogoInverse />
          </ParkChicagoLogoContainer>
        </HeaderContainer>
        <Nav open={this.state.open}>
          <Header>{'Parking'}</Header>
          <Link to="/history" onClick={this.close}>
            <IconContainer type="calendar" /> {'Parking History'}
          </Link>

          <Header>{'Fleet Management'}</Header>
          <Link to="/profile" onClick={this.close}>
            <IconContainer type="profile" /> {'Profile'}
          </Link>
          <Link to="/members" onClick={this.close}>
            <IconContainer type="members" /> {'Members'}
          </Link>
          <Link to="/billing" onClick={this.close}>
            <IconContainer type="billing" /> {'Billing'}
          </Link>
          <ExternalLink
            href={TERMS_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={this.close}>
            <IconContainer type="terms" /> {TERMS_NAV_LABEL}
          </ExternalLink>
          <Link to="/logout" onClick={this.close}>
            <IconContainer type="logout" /> {'Logout'}
          </Link>
        </Nav>
        <FooterLogo>
          <PoweredByPassport />
        </FooterLogo>
      </div>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/App/Navigation.js